<template>
  <div class="shelves-box">
    <div>
    <img src="@/assets/img/qietu/appshelves.png" alt="" />
    <p>已下架</p>
  </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang='scss' scoped>
.shelves-box {
  padding-top: 30vh;
  height: 100vh;
  text-align: center;
  background-color: #fff;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  img {
    width: 167px;
    height: 183px;
  }
  p {
    margin-top: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #666666;
  }
}
</style>